import {
    Bank,
    CreditCard,
    DeviceMobile,
    Storefront,
} from '@phosphor-icons/react'

import './PaymentConfigPage.scss'

const paymentMethods = [
    {
        icon: <DeviceMobile size={20} />,
        title: 'E-wallets',
        description:
            'Touch ‘n Go, Grabpay, Boost',
    },
    {
        icon: <CreditCard size={20} />,
        title: 'Credit / Debit Card',
        description:
            'Visa, Mastercard supported',
    },
    {
        icon: <Bank size={20} />,
        title: 'FPX',
        description: 'FPX online banking',
    },
    {
        icon: <Storefront size={20} />,
        title: 'Pay at Counter',
        description: 'Dine-in only',
    },
]

export default function PaymentConfigPage() {
    return (
        <div className="payment-config-page">
            <div className="page-header">
                <div>
                    <div className="page-breadcrumb">
                        Hikaya House /{' '}
                        <strong>
                            Payment config
                        </strong>
                    </div>

                    <h1>
                        Payment configuration
                    </h1>

                    <p>
                        Payment methods, gateway and tax
                    </p>
                </div>

                <button className="btn-primary">
                    Save changes
                </button>
            </div>

            <div className="payment-grid">
                <div className="payment-card">
                    <div className="payment-card__header">
                        <h2>
                            Payment methods
                        </h2>
                    </div>

                    <div className="payment-methods">
                        {paymentMethods.map(
                            (method, index) => (
                                <div
                                    className="payment-method"
                                    key={index}
                                >
                                    <div className="payment-method__left">
                                        <div className="payment-method__icon">
                                            {method.icon}
                                        </div>

                                        <div>
                                            <h3>
                                                {
                                                    method.title
                                                }
                                            </h3>

                                            <p>
                                                {
                                                    method.description
                                                }
                                            </p>
                                        </div>
                                    </div>

                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            defaultChecked
                                        />

                                        <span className="slider" />
                                    </label>
                                </div>
                            )
                        )}
                    </div>
                </div>

                <div className="payment-card">
                    <div className="payment-card__header">
                        <h2>
                            Fiuu gateway
                        </h2>
                    </div>

                    <div className="gateway-form">
                        <div className="form-group">
                            <label>
                                Merchant code
                            </label>

                            <input
                                type="text"
                                value="1234567890"
                                readOnly
                            />
                        </div>

                        <div className="form-group">
                            <label>
                                Merchant key
                            </label>

                            <input
                                type="password"
                                value="abcdefghij"
                                readOnly
                            />
                        </div>

{/*                        <div className="form-group">
                            <label>
                                Return URL
                            </label>

                            <input
                                type="text"
                                value="https://order.hikarihouse.my/payment/return"
                                readOnly
                            />
                        </div>*/}
                    </div>
                </div>
            </div>
        </div>
    )
}